<div class="accordion-item">
  <h2 class="accordion-header">
    <button
      class="accordion-button"
      [class.collapsed]="!expanded"
      type="button"
      (click)="expanded = !expanded"
      [attr.aria-expanded]="expanded"
      [attr.aria-controls]="panelId"
    >
      <label>{{ 'dataconnection.configuration' | translate }}</label>
    </button>
  </h2>
  <div
    [id]="panelId"
    class="accordion-collapse collapse"
    [class.show]="expanded"
  >
    <div class="accordion-body">
      <div class="col-md-12 form-group">
        <p>
          <span>{{
            'dataconnection.configuration_description' | translate
          }}</span
          >&nbsp;<a [href]="documentationUrl" target="_blank" rel="noopener">{{
            'dataconnection.docs' | translate
          }}</a>
        </p>
        <app-input-with-error
          [control]="control"
          inputType="textarea"
          (keyUpEvent)="keyUpEvent.emit($event)"
        ></app-input-with-error>
      </div>
    </div>
  </div>
</div>
<ng-content />
